import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTreeNode = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 10,
	viewBox: "0 0 12 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M0 2C0 0.89543 0.89543 0 2 0H10C11.1046 0 12 0.89543 12 2C12 3.10457 11.1046 4 10 4H3V6.5C3 6.77614 3.22386 7 3.5 7H5.26756C5.61337 6.4022 6.25972 6 7 6H10C11.1046 6 12 6.89543 12 8C12 9.1046 11.1046 10 10 10H7C5.89543 10 5 9.1046 5 8H3.5C2.67157 8 2 7.3284 2 6.5V4C0.89543 4 0 3.10457 0 2ZM2 3H10C10.5523 3 11 2.55228 11 2C11 1.44772 10.5523 1 10 1H2C1.44772 1 1 1.44772 1 2C1 2.55228 1.44772 3 2 3ZM7 7C6.44772 7 6 7.4477 6 8C6 8.5523 6.44772 9 7 9H10C10.5523 9 11 8.5523 11 8C11 7.4477 10.5523 7 10 7H7Z",
		fill: "#5D6A85"
	})
});
export default SvgTreeNode;
